function formatDate(date, splitChar = '/', joinChar = '-') {
  return (date || '').split(splitChar).reverse().join(joinChar)
}

export default formatDate
